import { TRANSITION_STYLE } from "../constants";
import type { OrganSvgProps } from "../types";

export function Prenetal({ style, colorScale, isActive = false, className }: OrganSvgProps) {
  const defaultColor = colorScale[300];
  const activeColor = colorScale[300];
  const fill = style?.fill ?? (isActive ? activeColor : defaultColor);

  return (
    <g className={className} data-organ="prenetal">
      <path
        d={PRENETAL_PATH}
        fill={fill}
        stroke={style?.stroke}
        strokeWidth={style?.strokeWidth}
        style={{ transition: TRANSITION_STYLE }}
      />
    </g>
  );
}

const PRENETAL_PATH =
  "M22.8833 11.3487C23.0591 10.2417 24.641 9.38036 25.7359 9.64162C27.9844 10.1639 29.9478 11.6287 31.2785 12.926C31.7732 13.4074 31.9913 13.5494 32.3096 13.3794C32.3096 13.3794 33.17 12.3268 33.6343 12.5277C34.0986 12.7286 34.0556 13.5158 33.8627 13.9158C33.3813 14.9053 31.3238 15.0517 29.8025 15.0418C29.1724 15.0403 29.1906 15.6672 29.431 16.2547C32.1927 22.984 25.6292 25.9865 19.5769 22.5988C17.0388 21.1748 15.2473 19.1104 13.325 17.2751C11.2889 15.3283 7.30778 17.3163 4.07086 14.9013C-1.81731 10.4858 -0.800527 4.3803 3.82488 1.3048C7.97048 -1.45449 11.5335 0.695054 13.2748 2.85125C13.9831 3.72545 14.3478 5.47286 15.1735 6.21835C16.1536 7.10024 17.5359 5.80462 17.9111 8.60047C18.1807 10.5961 17.2051 12.0128 15.5749 13.073C15.9938 13.8952 16.4086 13.5252 16.7977 13.4042C17.5039 13.1933 18.357 13.6686 19.1195 13.6176C19.6674 13.5799 19.9731 12.9759 19.697 12.4975L18.5429 10.8041C18.3882 10.5394 18.4151 10.2104 18.6105 9.97628L19.474 8.95069C19.8048 8.5627 20.4354 8.62309 20.6651 9.08139C20.9634 9.67929 20.3574 10.102 20.3914 10.6662C20.4254 11.2303 21.2529 12.8044 21.9626 13.4008C22.4081 13.7657 23.0765 13.4285 23.0646 12.8556L22.8841 11.3381L22.8833 11.3487Z";
